
import React, { Suspense, useEffect, useRef } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import CacheBuster from 'react-cache-buster'
import NotificationAlert from 'react-notification-alert'

import PublicLayout from './layouts/PublicLayout'
import SecureLayout from './layouts/SecureLayout'
import { SessionProvider } from './contexts/SessionProvider'
import { ThemeProvider } from './contexts/ThemeProvider'
import { VehiclesProvider } from './contexts/VehiclesProvider'
import { AuctionsProvider } from './contexts/AuctionsProvider'
import { TemplatesProvider } from './contexts/TemplatesProvider'
import { InspectionsProvider } from './contexts/InspectionsProvider'
import { subscribe, unsubscribe } from './events/customEvents'

import packageData from '../package.json'
const Environment = require('./environments/environment.json')

const App = () =>
{
	const isProduction = Environment.environmentName === 'production'
	const notificationAlertRef = useRef(null)
	
	useEffect(() =>
	{
		subscribe('raiseNotification', (event) => handleRaiseNotification(event))
		
		return () =>
		{
			unsubscribe('raiseNotification', (event) => handleRaiseNotification(event))
		}
	})
	
	const handleRaiseNotification = (event) =>
	{
		if (event)
		{
			try
			{
				event.preventDefault()
				
				let options =
				{
					place: "tc",
					message: (
						<div className="alert-text">
							<span className="alert-title" data-notify="title">
								{" "}
								{event.detail.title}
							</span>
									<span data-notify="message">
								{event.detail.message}
							</span>
						</div>
					),
					type: event.detail.type,
					icon: "ni ni-bell-55",
					autoDismiss: event.detail.duration,
				}
				notificationAlertRef.current.notificationAlert(options)
			}
			catch {}
		}
	}
	
	return (
		<CacheBuster
			isEnabled={ isProduction }
			onCacheClear={ () => {} }
			currentVersion={ packageData.version }
		>
			<Suspense fallback={ <div>Loading...</div> }>
				<div className="App">
					<SessionProvider>
						<VehiclesProvider>
							<AuctionsProvider>
								<TemplatesProvider>
									<InspectionsProvider>
										<ThemeProvider>
											<BrowserRouter
												future={{
													v7_startTransition: true,
													v7_relativeSplatPath: true,
												}}
											>
												<Routes>
													<Route path="*" element={ <PublicLayout /> } />
													<Route path="/public/*" element={ <PublicLayout /> } />
													<Route path="/secure/*" element={ <SecureLayout /> } />
													<Route path="*" element={ <Navigate to="/" replace/> } />
												</Routes>
											</BrowserRouter>
										</ThemeProvider>
									</InspectionsProvider>
								</TemplatesProvider>
							</AuctionsProvider>
						</VehiclesProvider>
					</SessionProvider>
					<div className="rna-wrapper">
						<NotificationAlert ref={notificationAlertRef} />
					</div>
				</div>
			</Suspense>
		</CacheBuster>
	)
}

export default App
